<div *ngIf="!menuMode" class="no-print">
  <div class="box-header pageheader row">
    <div class="col-sm-12 noPaddingAll">

      <div class="col-sm-4 text-left noPaddingAll displayInline">
        <h3>{{title}}</h3>
      </div>

      <div class="card flex col-sm-8 text-right noPaddingAll" *ngIf="menuItems && menuItems.length > 0"  style=" display: inline-block;">
        <p-menu #menu [model]="menuItems" [popup]="true" appendTo="body" baseZIndex="1000"></p-menu>
        <p-button (click)="menu.toggle($event)" icon="pi pi-ellipsis-v"></p-button>
      </div>
    </div>
  </div>
</div>

 <div *ngIf="menuMode" class="no-print">
  <div class="box-header pageheader row">
    <div class="col-sm-12 noPaddingAll">

      <div class="col-sm-4 text-left noPaddingAll">
        <h3 style="display: inline-block;">{{title}}</h3>
      </div>

      <div class="col-sm-2 text-center noPaddingAll">
        <a href="javascript:void(0)" (click)="SearchClick()" style="display: inline-block;" class="btn"
          [class.btn-primary]="isSearchOpen===false" [class.btn-danger]="isSearchOpen===true" *ngIf="showSearch"
          id="btnSearch"> <i class="fa fa-search"></i> &nbsp; <span>{{searchText}}</span> </a>
      </div>
      <div class="col-sm-6 text-right noPaddingAll">
        <div class="input-group" *ngIf="showScanbox" style="width: 250px;display: inline-flex;">
          <input type="text" class="form-control" placeholder="Scan Equipment" id="txtSearch">

          <img src="../../assets/img/scan icon.png" alt="Scan Icon" style="position: relative;
                                    right: 35px;
                                    width: 35px;
                                    height: 35px;
                                    cursor: pointer;
                                    z-index: 10;" />
        </div>
        <a href="javascript:void(0)" (click)="RouteClick(addurl)" *ngIf="showAddNew" class="btn btn-primary grayButton "
          id="btnAddNew" title="Add New"> <i class="fa fa-plus"></i> &nbsp; Add New </a>
        <a href="javascript:void(0)" (click)="AddNoteClick()" class="btn btn-primary" *ngIf="showNote" id="btnNote"
          title="Add Note"> <i class="fa fa-edit"></i> &nbsp; <span>Add Note</span> </a>
        <a href="javascript:void(0)" (click)="EditClick()" class="btn btn-primary" *ngIf="showEdit" id="btnEdit"
          title="Edit"> <i class="fa fa-edit"></i> &nbsp; <span>Edit</span> </a>
        <a href="javascript:void(0)" (click)="SaveClick()" class="btn btn-primary" *ngIf="showSave" id="btnSave"
          title="Save"> <i class="fa fa-save"></i> &nbsp; <span>Save</span> </a>
        <a href="javascript:void(0)" (click)="CancelClick()" class="btn btn-primary" *ngIf="showCancel" id="btnCancel"
          title="Cancel"> <i class="fa fa-close"></i> &nbsp; <span>Cancel</span> </a>
        <a href="javascript:void(0)" (click)="Print()" class="btn btn-success" *ngIf="showPrint" id="btnPrint"
          title="Print Schedule"><i class="fa fa-print"></i>&nbsp; <span>Print Schedule</span></a>
        <a href="javascript:void(0)" (click)="RouteClick(mainlisturl)" class="btn btn-primary"
          *ngIf="showMainListing  && MainListingText != 'Cancel'" id="btnMainListing" title="Main Listing"> <i
            class="fa fa-list"></i> &nbsp; {{MainListingText}}</a>
        <a href="javascript:void(0)" (click)="RouteClick(mainlisturl)" class="btn btn-danger"
          *ngIf="showMainListing && MainListingText=='Cancel'" id="btnMainListing" title="Main Listing"> <i
            class="fa fa-close"></i> &nbsp; {{MainListingText}}</a>
        <a href="javascript:void(0)" (click)="PreviousPageClick()" class="btn btn-primary" *ngIf="showPreviousPage"
          id="btnPreviousPage"> <i class="fa fa-arrow-circle-left"></i> &nbsp; <span>Previous Page</span> </a>
        <a href="#" class="btn btn-primary" id="btnMoveUp" style="display: none;"> <i class="fa fa-arrow-up"></i> </a>
        <a href="#" class="btn btn-primary" id="btnMoveDown" style="display: none;"> <i class="fa fa-arrow-down"></i>
        </a>
        <a href="javascript:void(0)" (click)="DownloadTemplate()" class="btn btn-primary grayButton" *ngIf="showDownloadTemplate"
          id="btnDownloadTemplate" title="Download Template">
          <i class="fa fa-download"></i> &nbsp; Download Template
        </a>
        <a href="javascript:void(0)" (click)="ImportContact()" class="btn btn-info" *ngIf="showImportContact"
           title="Import Contact">
          <i class="fa fa-upload"></i> &nbsp; Import Contact
        </a>
        <a href="javascript:void(0)" (click)="ImportVendor()" class="btn btn-info" *ngIf="showImportVendor"
           title="Import Vendor">
          <i class="fa fa-upload"></i> &nbsp; Import Vendor
        </a>
        <a href="javascript:void(0)" (click)="ImportContact()" class="btn btn-info" *ngIf="showImportParts"
           title="Import Parts">
          <i class="fa fa-upload"></i> &nbsp; Import Parts
        </a>
        <a href="javascript:void(0)" (click)="ImportContact()" class="btn btn-info" *ngIf="showImportEquipment"
            title="Import Equipment">
          <i class="fa fa-upload"></i> &nbsp; Import Equipment
        </a>
      </div>
    </div>

  </div>  
</div>  
    

 
